export default {"src":"/_next/static/media/service-default-dark.93aa8d1d.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};